package org.dronda.lib.validation.rules

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import org.dronda.lib.validation.ValidationError
import kotlin.jvm.JvmInline

private val emailRegex = """^\S+@\S+\.\S+${'$'}""".toRegex()

@JvmInline
value class Email internal constructor(val value: String) {
    companion object {
        fun of(value: String): Result<Email, ValidationError> = email(value)
    }
}

data class InvalidEmail(val email: String) : ValidationError()

fun email(value: String): Result<Email, ValidationError> {
    return if (emailRegex.matches(value)) {
        Ok(Email(value))
    } else {
        Err(InvalidEmail(value))
    }
}

data object DoesNotMatch : ValidationError()

fun matchesString(value: String, expected: String): Result<String, ValidationError> {
    return if (value == expected) {
        Ok(value)
    } else {
        Err(DoesNotMatch)
    }
}